import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { apiLogin } from "../services/dataService";
import logo from "../assets/cardiohard-logo1.png";

export default function Login({ onLogin }) {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const usuario = await apiLogin(email, password);
      login(usuario);
      onLogin?.(usuario);
    } catch {
      setError("Credenciales inválidas");
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <img src={logo} alt="CardioHard"/>
          </div>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>Email</label>
            <input 
              type="email" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@cardiohard.com"
              required
              className="input"
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label>Contraseña</label>
            <input 
              type="password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              className="input"
              disabled={loading}
            />
          </div>
          
          {error && <p className="error-message">{error}</p>}
          
          <button 
            type="submit" 
            disabled={!email || !password || loading}
            className="btn btn--primary btn--block"
          >
            {loading ? "Ingresando..." : "Ingresar"}
          </button>
        </form>
        
        <div className="login-help">
          <p><strong>🔐 Credenciales:</strong></p>
          <p>• Admin: <code>admin@cardiohard.com</code> / <code>admin</code></p>
          <p>• Técnico: <code>tecnico@cardiohard.com</code> / <code>tecnico</code></p>
        </div>
      </div>
    </div>
  );
}